"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.button.login': 'Iniciar Sesión Ahora',
    'activate.button.back_login': 'Volver al Inicio de Sesión',
    'activate.button.register_again': 'Registrarse Nuevamente',
};
